var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "vue-toast-opacity" } }, [
    _c(
      "div",
      {
        staticClass: "vue-toast_container",
        class: [_vm.theme],
        style: _vm.style,
        on: { mouseover: _vm._stopTimer, mouseleave: _vm._startTimer }
      },
      [
        _c("div", { staticClass: "vue-toast_message" }, [
          _c("span", { domProps: { innerHTML: _vm._s(_vm.message) } }),
          _vm._v(" "),
          _vm.options.closeBtn
            ? _c("span", {
                staticClass: "vue-toast_close-btn",
                on: { click: _vm.remove }
              })
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }